import { useEffect, useState } from "react"

//api
import { TemplateService } from "../../../../service/template-service"

//components
import { Dialog } from "primereact/dialog"; 
import ReactMarkdown from 'react-markdown';

const TemplateFiles = ({templateId}) => {
    const [folder, setFolder] = useState(null)
    const [openFolders, setOpenFolders] = useState({}); 
    const [fileContent, setFileContent] = useState(null); 
    const [previewVisible, setPreviewVisible] = useState(false); 
    const [previewFileName, setPreviewFileName] = useState('');
    // eslint-disable-next-line no-unused-vars
    const [fileUrl, setFileUrl] = useState(null); 

    useEffect(()=>{
        const fetchFolder = () => {
            TemplateService.getFolderStructure(
                templateId,
                (data)=>{
                    if(data && typeof data === 'object' && Array.isArray(data.children)){
                        setFolder(data.children)
                    } else {
                        console.error("API returned non-array data for folder structure:", data);
                        setFolder(null);
                    }
                }
            )
        }
        fetchFolder()
    }, [templateId])

    const toggleFolder = (folderPath) => {
        setOpenFolders(prev => ({
            ...prev,
            [folderPath]: !prev[folderPath] 
        }));
    };
    
   const handleFileClick = (fileItem) => {

        const fullPath = fileItem.path; 
        setFileContent(null);
        setFileUrl(null);
        setPreviewVisible(true); 
        setPreviewFileName(fileItem.name);

        TemplateService.getFile(
            templateId,
            fullPath,
            (response) => {
                    if (response && typeof response === 'object' && typeof response.content === 'string') {
                        setFileContent(response.content);
                        setFileUrl(null); 
                    } else {
                        console.error("Unexpected API response structure for text file content:", response);
                        hidePreviewDialog();
                    }
                }

        );
    };

    const hidePreviewDialog = ()=>{
        setPreviewVisible(false);
        setFileContent(null);
        setPreviewFileName('');
    }

    const renderItems = (items) => {
        if(!items || items.length === 0){
            return null;
        }

        return (
            <ul className="template__filesList">
                {items.map((item) => {
                    if(item.type === 'file' && (item.name.endsWith('.zip') || item.name.endsWith('.ZIP'))){
                        return null; 
                    }

                    if(item.name === 'template'){
                        return null
                    }

                    return(
                    <li key={item.path} className={`template__FilesItem ${item.type}`}>
                        {item.type === 'directory' ?(
                            <>
                                <div
                                    className="template__FolderHeader"
                                    onClick={() => toggleFolder(item.path)}
                                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                >
                                    <i className={`pi ${openFolders[item.path] ? 'pi-angle-down' : 'pi-angle-right'}`}
                                       style={{ marginRight: '8px' }}></i>

                                    <i className="pi pi-folder" style={{ marginRight: '5px' }}></i>
                                    <strong>{item.name}</strong>
                                </div>
                                {openFolders[item.path] && item.children && item.children.length > 0 && (
                                    renderItems(item.children)
                                )}
                            </>
                        ) : (
                            <div className="template__FileItem" style={{ display: 'flex', alignItems: 'center', marginLeft: '25px', cursor: 'pointer' }} onClick={() => handleFileClick(item)}>
                                <i className="pi pi-file" style={{ marginRight: '5px' }}></i>
                                <span className="template__File" style={{ textDecoration: 'underline' }}>{item.name}</span>
                            </div>
                        )}
                    </li>)
                })}
            </ul>
        )
    }

    

    return (
        <div className="template__FileContainer">
            {folder ? (
                <div className="template__FileViewer">
                    
                    {folder && folder.length > 0 ? (
                        renderItems(folder)
                    ) : null}
                </div>
            ) : null}
            <Dialog
                header={`Contenuto di: ${previewFileName}`}
                visible={previewVisible}
                style={{ width: '80vw', height: '70vh' }}
                onHide={hidePreviewDialog}
                maximizable
            >
                {fileContent ? (
        
                    <div style={{ height: '100%', overflowY: 'auto', border: '1px solid #eee', padding: '15px', backgroundColor: '#f9f9f9' }}>
                        {previewFileName.endsWith('.md') ? (
                            <ReactMarkdown>{fileContent}</ReactMarkdown>
                        ) : (
                            
                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{fileContent}</pre>
                        )}
                    </div>
                ) : null}
            </Dialog>
        </div>
    )
}

export default TemplateFiles